
import React from 'react';
import './Configure.scss';

interface ConfigureProps {
  currentLanguage: string;
  setCurrentLanguage: (language: string) => void;
}

const Configure: React.FC<ConfigureProps> = ({ currentLanguage, setCurrentLanguage }) => {
  const languages = [
    { code: 'es', name: 'Spanish' },
    { code: 'hi', name: 'Hindi' },
    { code: 'zh', name: 'Mandarin Chinese' },
    { code: 'ar', name: 'Arabic' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'fr', name: 'French' },
    { code: 'ru', name: 'Russian' },
    { code: 'id', name: 'Indonesian' },
    { code: 'bn', name: 'Bengali' },
    { code: 'ur', name: 'Urdu' },
    { code: 'tr', name: 'Turkish' },
    { code: 'vi', name: 'Vietnamese' },
    { code: 'ja', name: 'Japanese' },
    { code: 'th', name: 'Thai' },
    { code: 'it', name: 'Italian' },
  ];

  return (
    <div className="configure-container">
      <div className="configure-content">
        <div className="configure-header">
          <h1 className="configure-title">Configure Settings</h1>
          <p className="configure-subtitle">Choose your preferred learning language</p>
        </div>
        
        <div className="configure-section">
          <label htmlFor="language-select" className="configure-label">
            <span className="label-icon">🌐</span>
            Select Language
          </label>
          <select
            id="language-select"
            value={currentLanguage}
            onChange={(e) => setCurrentLanguage(e.target.value)}
            className="configure-select"
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Configure;
